import Image from 'next/image'
import {cn} from '@/lib/utils'

export type BrandLogo = {
  src: string
  width: number
  height: number
  backgroundClassName: string
  imageClassName?: string
}

const BRAND_LOGO_BY_KEY: Record<string, BrandLogo> = {
  jotul: {
    src: '/product-logos/jotul-card.png',
    width: 376,
    height: 356,
    backgroundClassName: 'bg-white',
    // Compensate for the supplied artwork's large, uneven white margins.
    imageClassName: 'object-contain scale-[1.15] -translate-y-[10.204%]',
  },
  scan: {
    src: '/product-logos/scan-card.png',
    width: 184,
    height: 170,
    backgroundClassName: 'bg-white',
    imageClassName: 'object-contain',
  },
  atra: {
    src: '/product-logos/atra.svg',
    width: 838,
    height: 772,
    backgroundClassName: 'bg-[#03131c]',
    // The wordmark sits near the bottom of the supplied image.
    imageClassName: 'object-cover -translate-y-[20.408%]',
  },
  ild: {
    src: '/product-logos/ild.svg',
    width: 422,
    height: 390,
    backgroundClassName: 'bg-[#cd4934]',
    imageClassName: 'object-cover',
  },
}

const normalizeBrandKey = (value?: string) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

export function getProductBrandLogo(brandKey?: string, brandTitle?: string): BrandLogo {
  return (
    BRAND_LOGO_BY_KEY[normalizeBrandKey(brandKey)] ||
    BRAND_LOGO_BY_KEY[normalizeBrandKey(brandTitle)] ||
    BRAND_LOGO_BY_KEY.jotul
  )
}

export function ProductBrandBadge({
  logo,
  label,
  size = 49,
}: {
  logo: BrandLogo
  label: string
  size?: 49 | 64
}) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-[3px]',
        size === 64 ? 'size-16' : 'size-[49px]',
        logo.backgroundClassName,
      )}
    >
      <Image
        src={logo.src}
        alt={label}
        width={logo.width}
        height={logo.height}
        sizes={`${size}px`}
        className={cn('h-full w-full', logo.imageClassName)}
      />
    </div>
  )
}
